<template>
  <el-dialog
    :title="$t('components.OrderDetailDialog.971063-0')"
    :visible.sync="dialogVisible"
    width="1200px"
    :close-on-click-modal="false"
    :modal-append-to-body="true"
    :append-to-body="true"
    @close="handleClose"
    class="order-detail-dialog"
  >
    <!-- 订单信息 -->
    <div class="order-info-section">
      <div class="order-info-header">
        <div class="order-info-item">
          <span class="label">{{ $t("components.OrderDetailDialog.971063-1") }}</span>
          <span class="value">{{ localOrderInfo.orderNo || "-" }}</span>
        </div>
        <div class="order-info-item">
          <span class="label">{{ $t("components.OrderDetailDialog.971063-2") }}</span>
          <span class="value">{{ localOrderInfo.userName || "-" }}</span>
        </div>
      </div>
    </div>

    <!-- 设备详情 -->
    <div class="equipment-section">
      <el-row :gutter="20">
        <!-- 左侧：设备分组 -->
        <el-col :span="6">
          <div class="team-list">
            <div v-if="teamList.length === 0" class="team-empty">
              <i class="el-icon-folder-opened empty-icon"></i>
              <div class="empty-text">{{ $t("components.OrderDetailDialog.971063-3") }}</div>
            </div>
            <div
              v-else
              v-for="team in teamList"
              :key="team.id"
              :class="['team-item', { active: currentTeamId === team.id }]"
              @click="handleTeamClick(team)"
            >
              <div class="team-name">{{ team.name }}</div>
              <div class="team-status">
                <span :class="['status-badge', team.transferStatus === 1 ? 'transferred' : 'untransferred']">
                  {{
                    team.transferStatus === 1
                      ? $t("components.OrderDetailDialog.971063-4")
                      : $t("components.OrderDetailDialog.971063-5")
                  }}
                </span>
              </div>
            </div>
          </div>
        </el-col>

        <!-- 右侧：设备列表 -->
        <el-col :span="18">
          <div class="equipment-list">
            <!-- 搜索栏 -->
            <div class="search-bar">
              <el-input
                v-model="equipmentSearch.equipmentNo"
                :placeholder="$t('components.OrderDetailDialog.971063-6')"
                clearable
                style="width: 200px; margin-right: 10px"
                size="small"
              />
              <el-input
                v-model="equipmentSearch.equipmentName"
                :placeholder="$t('components.OrderDetailDialog.971063-7')"
                clearable
                style="width: 200px; margin-right: 10px"
                size="small"
              />
              <el-button type="primary" @click="handleEquipmentSearch" icon="el-icon-search" size="small">{{
                $t("components.OrderDetailDialog.971063-8")
              }}</el-button>
              <el-button @click="handleEquipmentReset" icon="el-icon-refresh" size="small">{{
                $t("components.OrderDetailDialog.971063-9")
              }}</el-button>
            </div>

            <!-- 设备表格 -->
            <el-table
              v-loading="equipmentLoading"
              :data="equipmentList"
              border
              stripe
              style="width: 100%; margin-top: 15px"
              max-height="400"
              @sort-change="handleEquipmentSortChange"
            >
              <el-table-column prop="equipmentNo" :label="$t('components.OrderDetailDialog.971063-6')" width="150" />
              <el-table-column prop="equipmentName" :label="$t('components.OrderDetailDialog.971063-7')" width="150" />
              <el-table-column
                prop="createTime"
                :label="$t('components.OrderDetailDialog.971063-10')"
                width="180"
                sortable="custom"
              />
              <el-table-column
                prop="transferTime"
                :label="$t('components.OrderDetailDialog.971063-11')"
                width="180"
                sortable="custom"
              >
                <template slot-scope="scope">
                  {{ scope.row.transferTime || "-" }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('components.OrderDetailDialog.971063-12')" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="handlePrint(scope.row)"
                    :disabled="!scope.row.print || printingItems[scope.row.id]"
                    :loading="printingItems[scope.row.id]"
                  >
                    {{
                      printingItems[scope.row.id]
                        ? $t("components.OrderDetailDialog.971063-13")
                        : $t("components.OrderDetailDialog.971063-14")
                    }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">{{ $t("components.OrderDetailDialog.971063-15") }}</el-button>
      <el-button type="primary" @click="handlePrintAll" :loading="printing" size="small">
        {{ $t("components.OrderDetailDialog.971063-16") }}
      </el-button>
      <el-button type="primary" @click="handleConfirm" :loading="confirming" size="small">
        {{ $t("components.OrderDetailDialog.971063-17") }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import VTMPrintService from "@/utils/printSdk/VTMPrintService";

  export default {
    name: "OrderDetailDialog",
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      orderId: {
        type: String,
        default: ""
      },
      orderInfo: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        dialogVisible: false,
        loading: false,
        equipmentLoading: false,
        printing: false,
        confirming: false,
        localOrderInfo: {},
        teamList: [],
        currentTeamId: "",
        equipmentList: [],
        equipmentSearch: {
          equipmentNo: "",
          equipmentName: ""
        },
        equipmentSortConfig: {
          column: "",
          asc: true
        },
        printService: null,
        printingItems: {} // 正在打印的设备ID对象，key为设备ID，value为true
      };
    },
    mounted() {
      // 不再自动初始化打印服务，改为按需初始化
    },
    beforeDestroy() {
      // 销毁打印服务
      if (this.printService) {
        this.printService.destroy();
      }
    },
    watch: {
      visible(val) {
        this.dialogVisible = val;
        if (val && this.orderId) {
          this.initOrderInfo();
          this.loadTeamList();
        }
      },
      dialogVisible(val) {
        this.$emit("update:visible", val);
      }
    },
    methods: {
      // 懒加载初始化打印服务
      async initPrintService() {
        // 如果已经初始化成功，直接返回
        if (this.printService && this.printService.printSocketOpen) {
          return this.printService;
        }

        try {
          // 如果之前初始化失败，先清理
          if (this.printService) {
            try {
              this.printService.destroy();
            } catch (e) {
              // 忽略销毁错误
            }
            this.printService = null;
          }

          // 创建打印服务实例，但不自动初始化
          this.printService = new VTMPrintService({
            autoInit: false, // 禁用自动初始化
            errorHandler: "callback",
            onError: message => {
              // 只在真正需要打印时才显示错误
              this.$message.error(message);
            }
          });

          // 手动初始化打印服务
          await this.printService.init();
          return this.printService;
        } catch (err) {
          // 初始化失败时，清理实例并返回null
          if (this.printService) {
            try {
              this.printService.destroy();
            } catch (e) {
              // 忽略销毁错误
            }
            this.printService = null;
          }
          // 静默处理，不显示错误（因为用户可能只是查看，不需要打印）
          return null;
        }
      },

      // 初始化订单信息
      initOrderInfo() {
        if (this.orderInfo && this.orderInfo.id) {
          this.localOrderInfo = {
            id: this.orderInfo.id,
            orderNo: this.orderInfo.orderNo || "-",
            userName: this.orderInfo.userName || "-",
            insertUid: this.orderInfo.insertUid || "",
            notes: this.orderInfo.notes || ""
          };
        } else {
          this.localOrderInfo = {
            orderNo: "-",
            userName: "-"
          };
        }
      },

      // 加载设备分组列表
      loadTeamList() {
        if (!this.orderId) return;
        this.loading = true;
        this.$api
          .request(this.$url.ShippingOrder.getEquipmentTeamByOrderId, this.$method.get, {
            orderId: this.orderId
          })
          .then(res => {
            if (res.code === 0) {
              // 处理分页数据结构，从 records 中获取分组列表
              this.teamList = Array.isArray(res.data?.records)
                ? res.data.records
                : Array.isArray(res.data)
                ? res.data
                : [];
              if (this.teamList.length > 0) {
                this.currentTeamId = this.teamList[0].id;
                this.loadEquipmentList();
              }
            } else {
              this.$message.error(res.msg || this.$t("components.OrderDetailDialog.971063-19"));
            }
          })
          .catch(err => {
            this.$message.error(this.$t("components.OrderDetailDialog.971063-20"));
          })
          .finally(() => {
            this.loading = false;
          });
      },

      // 点击分组
      handleTeamClick(team) {
        this.currentTeamId = team.id;
        this.loadEquipmentList();
      },

      // 加载设备列表
      loadEquipmentList() {
        if (!this.currentTeamId) return;
        this.equipmentLoading = true;
        const params = {
          teamId: this.currentTeamId,
          equipmentNo: this.equipmentSearch.equipmentNo || undefined,
          equipmentName: this.equipmentSearch.equipmentName || undefined
        };

        // 添加排序
        if (this.equipmentSortConfig.column) {
          params.orders = [
            {
              column: this.equipmentSortConfig.column,
              asc: this.equipmentSortConfig.asc
            }
          ];
        }

        this.$api
          .request(this.$url.ShippingOrder.getEquipmentByTeamId, this.$method.get, params)
          .then(res => {
            if (res.code === 0) {
              this.equipmentList = (res.data && res.data.records) || [];
            } else {
              this.$message.error(res.msg || this.$t("components.OrderDetailDialog.971063-21"));
            }
          })
          .catch(err => {
            this.$message.error(this.$t("components.OrderDetailDialog.971063-20"));
          })
          .finally(() => {
            this.equipmentLoading = false;
          });
      },

      // 设备搜索
      handleEquipmentSearch() {
        this.loadEquipmentList();
      },

      // 设备重置
      handleEquipmentReset() {
        this.equipmentSearch = {
          equipmentNo: "",
          equipmentName: ""
        };
        this.equipmentSortConfig = {
          column: "",
          asc: true
        };
        this.loadEquipmentList();
      },

      // 设备排序
      handleEquipmentSortChange({ prop, order }) {
        if (order) {
          this.equipmentSortConfig = {
            column: prop,
            asc: order === "ascending"
          };
        } else {
          this.equipmentSortConfig = {
            column: "",
            asc: true
          };
        }
        this.loadEquipmentList();
      },

      // 打印单个设备
      async handlePrint(row) {
        if (!row.print) {
          this.$message.warning(this.$t("components.OrderDetailDialog.971063-22"));
          return;
        }

        // 如果正在打印，直接返回
        if (this.printingItems[row.id]) {
          return;
        }

        // 先显示打印状态，提供即时反馈
        this.$set(this.printingItems, row.id, true);
        this.$forceUpdate(); // 强制更新视图

        try {
          // 懒加载初始化打印服务
          const printService = await this.initPrintService();
          if (!printService) {
            this.$message.error(this.$t("components.OrderDetailDialog.971063-23"));
            return;
          }

          const printInfo = row.print;
          const result = await printService.print({
            machineType: printInfo.machineType || "",
            imei: printInfo.imei || "",
            sn: printInfo.cardReader || "",
            help: printInfo.help || "",
            company: printInfo.company || ""
          });

          if (result.success) {
            this.$message.success(this.$t("components.OrderDetailDialog.971063-24"));
          } else {
            this.$message.error(result.message || this.$t("components.OrderDetailDialog.971063-25"));
          }
        } catch (err) {
          this.$message.error(
            this.$t("components.OrderDetailDialog.971063-27") +
              (err.message || this.$t("components.OrderDetailDialog.971063-28"))
          );
        } finally {
          // 移除打印状态
          this.$set(this.printingItems, row.id, false);
          this.$forceUpdate(); // 强制更新视图
        }
      },

      // 打印全部
      async handlePrintAll() {
        const printableEquipments = this.equipmentList.filter(item => item.print);
        if (printableEquipments.length === 0) {
          this.$message.warning(this.$t("components.OrderDetailDialog.971063-29"));
          return;
        }

        // 先显示打印状态，提供即时反馈
        this.printing = true;
        // 为所有设备设置打印状态
        printableEquipments.forEach(item => {
          this.$set(this.printingItems, item.id, true);
        });
        this.$forceUpdate(); // 强制更新视图

        let successCount = 0;
        let failCount = 0;

        try {
          // 懒加载初始化打印服务
          const printService = await this.initPrintService();
          if (!printService) {
            this.$message.error(this.$t("components.OrderDetailDialog.971063-23"));
            return;
          }

          // 逐个打印设备
          for (let i = 0; i < printableEquipments.length; i++) {
            const item = printableEquipments[i];

            try {
              const printInfo = item.print;
              const result = await printService.print({
                machineType: printInfo.machineType || "",
                imei: printInfo.imei || "",
                sn: printInfo.cardReader || "",
                help: printInfo.help || "",
                company: printInfo.company || ""
              });

              if (result.success) {
                successCount++;
              } else {
                failCount++;
              }

              // 每个设备打印间隔 500ms，避免过快
              if (i < printableEquipments.length - 1) {
                await new Promise(resolve => setTimeout(resolve, 500));
              }
            } catch (err) {
              failCount++;
            } finally {
              // 移除单个设备的打印状态
              this.$set(this.printingItems, item.id, false);
              this.$forceUpdate(); // 强制更新视图
            }
          }

          // 显示最终结果
          if (successCount > 0) {
            this.$message.success(this.$t("components.OrderDetailDialog.971063-32", [successCount, failCount]));
          } else {
            this.$message.error(this.$t("components.OrderDetailDialog.971063-34"));
          }
        } catch (err) {
          this.$message.error(
            this.$t("components.OrderDetailDialog.971063-36") +
              (err.message || this.$t("components.OrderDetailDialog.971063-28"))
          );
        } finally {
          this.printing = false;
          // 清空所有打印状态
          Object.keys(this.printingItems).forEach(key => {
            this.$set(this.printingItems, key, false);
          });
          this.$forceUpdate(); // 强制更新视图
        }
      },

      // 确认
      handleConfirm() {
        this.$confirm(
          this.$t("components.OrderDetailDialog.971063-37"),
          this.$t("components.OrderDetailDialog.971063-38"),
          {
            confirmButtonText: this.$t("components.OrderDetailDialog.971063-39"),
            cancelButtonText: this.$t("components.OrderDetailDialog.971063-15"),
            type: "warning"
          }
        )
          .then(() => {
            this.confirming = true;
            // 这里可以调用确认接口
            this.$message.success(this.$t("components.OrderDetailDialog.971063-40"));
            this.handleClose();
          })
          .catch(() => {})
          .finally(() => {
            this.confirming = false;
          });
      },

      // 关闭
      handleClose() {
        this.dialogVisible = false;
        this.localOrderInfo = {};
        this.teamList = [];
        this.currentTeamId = "";
        this.equipmentList = [];
        this.equipmentSearch = {
          equipmentNo: "",
          equipmentName: ""
        };
        this.equipmentSortConfig = {
          column: "",
          asc: true
        };
      }
    }
  };
</script>

<style scoped lang="scss">
  .order-detail-dialog {
    .order-info-section {
      margin-bottom: 24px;
      padding-bottom: 20px;
      border-bottom: 1px solid #f0f0f0;

      .order-info-header {
        display: flex;
        gap: 40px;

        .order-info-item {
          .label {
            font-size: 13px;
            color: #8c8c8c;
            margin-right: 8px;
          }

          .value {
            font-size: 14px;
            color: #262626;
            font-weight: 400;
          }
        }
      }
    }

    .equipment-section {
      .team-list {
        background: #fafafa;
        border-radius: 2px;
        overflow: hidden;
        min-height: 200px;

        .team-empty {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 60px 20px;
          color: #8c8c8c;

          .empty-icon {
            font-size: 40px;
            margin-bottom: 12px;
            color: #c0c4cc;
          }

          .empty-text {
            font-size: 13px;
            color: #909399;
          }
        }

        .team-item {
          padding: 16px 14px;
          cursor: pointer;
          border-bottom: 1px solid #f0f0f0;
          transition: all 0.2s ease;
          position: relative;

          &:last-child {
            border-bottom: none;
          }

          &:hover {
            background: #f5f5f5;
          }

          &.active {
            background: #ecf5ff;
            border-left: 2px solid #409eff;

            .team-name {
              color: #409eff;
              font-weight: 500;
            }
          }

          .team-name {
            font-size: 14px;
            font-weight: 400;
            color: #595959;
            margin-bottom: 6px;
            transition: color 0.2s;
          }

          .team-status {
            .status-badge {
              display: inline-block;
              padding: 1px 6px;
              border-radius: 1px;
              font-size: 11px;
              font-weight: 400;
              letter-spacing: 0.3px;

              &.untransferred {
                background: #fef0f0;
                color: #f56c6c;
                border: none;
              }

              &.transferred {
                background: #f0f9ff;
                color: #67c23a;
                border: none;
              }
            }
          }
        }
      }

      .equipment-list {
        .search-bar {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 16px;
        }
      }
    }

    .dialog-footer {
      text-align: right;
      padding-top: 16px;
      border-top: 1px solid #f0f0f0;
    }
  }
</style>

<style lang="scss">
  .order-detail-dialog {
    .el-dialog {
      border-radius: 0;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    .el-dialog__header {
      padding: 20px 24px;
      background: var(--vtm-surface);
      border-bottom: 1px solid #f0f0f0;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #8c8c8c;
      font-size: 18px;

      &:hover {
        color: #262626;
      }
    }

    .el-dialog__title {
      color: #262626;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0.2px;
    }

    .el-dialog__body {
      padding: 24px;
    }

    .el-dialog__footer {
      padding: 16px 24px;
    }

    .el-dialog__headerbtn {
      top: 20px;
      right: 24px;
    }

    // 表格样式优化
    .el-table {
      border: 1px solid #f0f0f0;

      th {
        background: #fafafa;
        color: #595959;
        font-weight: 500;
        font-size: 13px;
        border-bottom: 1px solid #f0f0f0;
      }

      td {
        border-bottom: 1px solid #f5f5f5;
        font-size: 13px;
        color: #262626;
      }

      .el-button--text {
        color: #409eff;
        padding: 0;
        font-size: 13px;

        &:hover {
          color: #66b1ff;
        }

        &:disabled {
          color: #c0c4cc;
        }
      }
    }

    // 输入框样式
    .el-input__inner {
      border-color: #dcdfe6;
      font-size: 13px;

      &:focus {
        border-color: #409eff;
      }
    }

    // 按钮样式保持 Element UI 默认
    .el-button {
      font-size: 13px;

      &.el-button--small {
        padding: 7px 15px;
        font-size: 12px;
      }
    }
  }
</style>
